// extracted by mini-css-extract-plugin
module.exports = {"root":"Files_root__2Odq_","fileItem":"Files_fileItem__1OjY2","file":"Files_file__1BSt5","separator":"Files_separator__3JZko"};